import { PropsWithChildren } from 'react';

export const ModalDialogSlot = {
  CloseButton: 'CloseButton',
  Header: 'Header',
  Body: 'Body',
  Footer: 'Footer',
} as const;

export type ModalDialogSlot = (typeof ModalDialogSlot)[keyof typeof ModalDialogSlot];

export type ModalProps = PropsWithChildren<{
  className?: string;
  width?: number;
}>;

export const ModalTheme = {
  Dark: 'dark',
  Light: 'light',
} as const;

export type ModalTheme = (typeof ModalTheme)[keyof typeof ModalTheme];

export type UseModalDialogProps = {
  id: string;
  closeOnOutsideClick?: boolean;
};
